<template>
    <div class="view-library">

        <!-- tabs -->
        <Tabs :routes="routes" />

        <!-- view -->
        <div class="view">
            <router-view :key="$route.fullPath" />            
        </div>

    </div>
</template>

<script>
import ANALYTICS from '@generio-ai/library-legacy/constants/analytics'
import ROUTES from '@generio-ai/library-legacy/constants/routes'
import { mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import Tabs from '@generio-ai/library-legacy/components/tabs'

export default {
    name: 'ViewLibrary',
    components: {
        Tabs
    },
    computed: {
        routes() {
            return [
                ROUTES.APPSUITE.LIBRARY_FLOWS,
                ROUTES.APPSUITE.LIBRARY_MODELS,
                ROUTES.APPSUITE.LIBRARY_IMAGES
            ]
        }
    },
    methods: {
        ...mapActions('analytics', [
            'logEvent'
        ])
    },
    mounted() {
        this.logEvent({
            name: ANALYTICS.EVENTS.VIEW_OPENED,
            description: 'Library view opened',
        })
    }
}
</script>

<style scoped>
.view-library {
    width: 100%;
    height: 100vh;
    box-sizing: border-box;
    display: block;
}

.view-library .view {
    width: 100%;
    height: calc(100vh - 64px);
    display: flex;
    flex-direction: column;
    background-color: rgb(var(--v-theme-darkbase));
}
</style>